/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alarm-plus': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3m-1 8a7 7 0 01-7-7 7 7 0 017-7 7 7 0 017 7 7 7 0 01-7 7m0-16a9 9 0 00-9 9 9 9 0 009 9 9 9 0 009-9 9 9 0 00-9-9m10 1.72l-4.6-3.86-1.29 1.53 4.6 3.86M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/>'
  }
})
